import {lazy} from 'react';

const NoPermissions = lazy(() => import('./NoPermissions'));

export default NoPermissions;
